import React from 'react';
import { Title } from '../../atoms';

const ProductActions = () => {
    return (
        <>
            <div className="productsActionCls">
                <Title text={"Select an item to edit details or remove"} className="emptyText" />
            </div >
        </>
    );
};

export default ProductActions;
